export const CustomizationLoader = {
  paths: [
    'SelfService',
    'GlobalBPOCore',
    'CustomPackage',
    'SteelOApp',
  ]
}



// WEBPACK FOOTER //
// ./src/customization/loader.js